/**
 * filter_selection_item__any__all__selection_item_TooltipText__Selected_and_Buttons.tsx
 *
 * In Filter Section of Single Protein
 *
 * Tooltips for use on Selected and Button
 *
 */

/**
 * For Selected entry
 */
export const filter_selection_item__any__all__selection_item_TooltipText__Selected = {

    _ADD__ONLY__TOOLTIP_MAIN_TEXT_STRING: "All peptides will have this item.",

    _OR__TOOLTIP_MAIN_TEXT_STRING: "All peptides will have this item OR any other items with the OR designation.",
    _AND__TOOLTIP_MAIN_TEXT_STRING: "All peptides will have this item AND any other items with the AND designation.",
    _NOT__TOOLTIP_MAIN_TEXT_STRING: "None of the peptides will have this item OR any other EXCLUDED items."
}

/**
 * For Buttons
 */
export const filter_selection_item__any__all__selection_item_TooltipText__Buttons = {

    _ADD__ONLY__TOOLTIP_MAIN_TEXT_STRING: "All peptides will have this item.",

    _OR__TOOLTIP_MAIN_TEXT_STRING: "Add to OR set. All peptides will contain at least one item in the OR set.",
    _AND__TOOLTIP_MAIN_TEXT_STRING: "Add to AND set. All peptides will contain all items in the AND set.",
    _NOT__TOOLTIP_MAIN_TEXT_STRING: "None of the peptides will have this item OR any other EXCLUDED items."
}


